@use "styles/mixins/_rem.scss" as rem;
@use "styles/mixins/_fonts.scss" as fonts;
@use "styles/mixins/_a11y.scss" as a11y;

.image-drag-and-drop-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.image-drag-and-drop {
  display: flex;
  height: rem.torem(240px);
  padding: var(--size-spacing-xl);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--size-spacing-s);
  align-self: stretch;
  position: relative;
  border-radius: var(--size-border-radius-s);

  &-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    color: rgb(0 0 0 / 0%);
    border-radius: var(--size-border-radius-s);
    border: rem.torem(1px) dashed var(--color-border-default);
    z-index: 1;

    &:not(&-error, &-disabled) {
      &:hover,
      &:focus,
      &:focus-visible {
        border: rem.torem(1px) dashed var(--color-border-brand-primary);
      }
    }

    &-error {
      border: rem.torem(1px) dashed var(--color-border-error);
    }

    &-disabled {
      cursor: default;
    }

    &::-webkit-file-upload-button,
    &::file-selector-button {
      visibility: hidden;
    }
  }

  &-dragged-over {
    border: rem.torem(1px) dashed var(--color-border-brand-primary);
  }

  &-dragged-over,
  &-hovered,
  &-focused,
  &-disabled {
    background-color: var(--color-background-subtle);
  }

  &-error {
    background: none;
  }

  &-text {
    @include fonts.body-s;

    display: flex;
    flex-direction: column;
    color: var(--color-text-subtle);
    text-align: center;

    &-or {
      display: inline;
      margin: 0;
    }

    &-highlight {
      @include fonts.button;

      color: var(--color-text-default);
      text-decoration-line: underline;
    }
  }

  &-description {
    @include fonts.body-accent-s;

    margin-top: var(--size-spacing-s);
    color: var(--color-text-default);
    display: flex;
    flex-direction: column;
    gap: var(--size-spacing-xs);

    &-list {
      display: flex;
      flex-direction: column;
      gap: var(--size-spacing-xs);
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &-error,
    &-validate {
      display: flex;
      align-items: center;
      gap: var(--size-spacing-xs);
    }

    &-icon {
      align-self: flex-start;
      flex-shrink: 0;
      margin-top: calc(
        (var(--typography-body-accent-s-line-height) - #{rem.torem(16px)}) / 2
      );
    }

    &-neutral {
      color: var(--color-text-disabled);
    }

    &-error {
      color: var(--color-text-error);
    }

    &-validate {
      color: var(--color-text-success);
    }

    &-values {
      @include fonts.body-s;
    }
  }
}

.visually-hidden {
  @include a11y.visually-hidden;
}
